import { render, staticRenderFns } from "./NewVenueProducts.vue?vue&type=template&id=f6ddab64&scoped=true&"
import script from "./NewVenueProducts.vue?vue&type=script&lang=js&"
export * from "./NewVenueProducts.vue?vue&type=script&lang=js&"
import style0 from "./NewVenueProducts.vue?vue&type=style&index=0&id=f6ddab64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ddab64",
  null
  
)

export default component.exports